const purchaseOrderUploadHeader = {
  'Purchase Order Number': 'po_number',
  'Purchase Order Net Value': 'po_net_value',
  'Purchase Order Balance Value': 'po_balance_value',
  'Transporter Ref ID': 'transporter_reference_id',
  'Purchase Order Line Item Number': 'po_line_number',
  'Account Assignment Number': 'account_assignment_number',
};

const purchaseOrderFieldType = {
  DATE: 'date',
  NUMBER: 'number',
  TEXTBOX: 'textbox',
};

const purchaseOrderStatus = {
  ACTIVE: 1,
  INACTIVE: 2,
  FUTURE: 3,
};

module.exports = {
  purchaseOrderUploadHeader,
  purchaseOrderFieldType,
  purchaseOrderStatus,
};
